
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import PokemonModule from "@/store/Pokemon";

@Component
export default class chooseFavorite extends Vue {
  @Prop({ required: true }) id!: number;
  inputValue = "";
  liste: string[] = [];
  created() {
    this.liste = PokemonModule.GetListe;
    // console.log("cereted func", this.liste);
  }
  create() {
    PokemonModule.SET_LİSTE(this.inputValue);
    // console.log("cereted func", this.liste);

    // const li = document.createElement("li");
    // const node = document.createTextNode(this.inputValue);
    // li.appendChild(node);
    // const ulli = document.querySelector("ul");
    // ulli?.appendChild(li);
    // this.liste.push(li);
    // this.liste.push(this.inputValue);
    this.inputValue = "";
  }
}
